// Vendor
import { useI18n } from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';

export default {
    name: "classifica",
    components: {
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent
    },
    data(){
        return {
            images: [
                {
                    "pid": "164",
                    "imgPath": "2021/164.jpg",
                    "selected": false
                },
                {
                    "pid": "515",
                    "imgPath": "2021/515.jpg",
                    "selected": false
                },
                {
                    "pid": "814",
                    "imgPath": "2021/814.jpg",
                    "selected": false
                },
                {
                    "pid": "1028",
                    "imgPath": "2021/1028.jpg",
                    "selected": false
                },
                {
                    "pid": "1107",
                    "imgPath": "2021/1107.jpg",
                    "selected": false
                },
                {
                    "pid": "1115",
                    "imgPath": "2021/1115.jpg",
                    "selected": false
                },
                {
                    "pid": "1135",
                    "imgPath": "2021/1135.jpg",
                    "selected": false
                },
                {
                    "pid": "1272",
                    "imgPath": "2021/1272.jpg",
                    "selected": false
                },
                {
                    "pid": "1273",
                    "imgPath": "2021/1273.jpg",
                    "selected": false
                },
                {
                    "pid": "1383",
                    "imgPath": "2021/1383.jpg",
                    "selected": false
                },
                {
                    "pid": "1995",
                    "imgPath": "2021/1995.jpg",
                    "selected": false
                },
                {
                    "pid": "2006",
                    "imgPath": "2021/2006.jpg",
                    "selected": false
                },
                {
                    "pid": "2303",
                    "imgPath": "2021/2303.jpg",
                    "selected": false
                },
                {
                    "pid": "2471",
                    "imgPath": "2021/2471.jpg",
                    "selected": false
                },
                {
                    "pid": "2723",
                    "imgPath": "2021/2723.jpg",
                    "selected": false
                },
                {
                    "pid": "2728",
                    "imgPath": "2021/2728.jpg",
                    "selected": false
                },
                {
                    "pid": "2812",
                    "imgPath": "2021/2812.jpg",
                    "selected": false
                },
                {
                    "pid": "4263",
                    "imgPath": "2021/4263.jpg",
                    "selected": false
                },
                {
                    "pid": "4631",
                    "imgPath": "2021/4631.jpg",
                    "selected": false
                },
                {
                    "pid": "4664",
                    "imgPath": "2021/4664.jpg",
                    "selected": false
                }

            ],
            currentPage: 1,
            maxImagesPerPage: 50,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
    computed:{
        /**
         * Filter images by current page and max images per page
         * @returns Array
         */
        paginatedImages() {
            let imagesUnshuffled = this.images;
            const imagesShuffled = imagesUnshuffled
                .map((value) => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value)
            return imagesShuffled.slice(0, this.currentPage * this.maxImagesPerPage);
        },

        /**
         * Check if there are another images or not
         * @returns {boolean}
         */
        numberTotal(){
            return (this.currentPage * this.maxImagesPerPage) < this.images.length
        }
    },
    methods:{
        // update page and load more images
        loadMore(){
            this.currentPage += 1;
        }
    }
}